module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Armless Sofa_Cloud.39d5328c.png";